module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fc-Gc-Hc-Ia.66952a5b.png";